import React from 'react';
import styled from 'styled-components';
import Button from '../../../components/atomic/Buttons/Button';
import ModalSelect from '../../../components/molecule/FormFields/ModalSelect';
import MultiTextInput from '../../../components/molecule/FormFields/MultiTextInput';
import tooltips from '../../../core/tooltips';
import { createSelect } from '../../../utils';
import { LIMITS } from '../../../core/constants';

const ModalSelectStyled = styled(ModalSelect)`
  margin-bottom: 8px;
`;
const HeaderContainer = styled.div`
  margin: 10px 0;
`;
const Header = styled.div`
  font-size: 20px;
  font-weight: 600;
`;
const SubHeader = styled.div`
  margin-top: 4px;
  font-size: 14px;
`;
const MultiTextInputStyled = styled(MultiTextInput)`
  margin-bottom: 8px;
`;
const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 4px;
`;

export default class MoreDetails extends React.Component {
  render() {
    const {
      values,
      handleBlur,
      saveButton,
      options,
      isSubmitting,
      changeTracker,
    } = this.props

    const equipmentSelect = createSelect('Choose Equipment', 'Choose Equipment', 'equipment',
      options.equipment_alt.map(item => ({ label: item.name, value: item.id, grouping: item.grouping.name })), true);
    const equipmentValue = values.equipment.map(item => ({ label: item.name, value: item.id }));

    const categorySelect = createSelect('Choose Categories', 'Choose Categories', 'category', options.categories.map(item => ({ label: item.name, value: item.name })), true);
    const categoryValue = values.categories.map(item => ({ label: item, value: item }));

    const musclegroupSelect = createSelect('Choose Muscle Groups', 'Choose Muscle Groups', 'musclegroup', options.musclegroups.map(item => ({ label: item.name, value: item.id })), true);
    const musclegroupValue = values.musclegroup.map(item => ({ label: item.name, value: item.id }));

    let fields = (
      <React.Fragment>
        <ModalSelectStyled
          text={equipmentSelect.buttonText}
          multiple={true}
          header="Equipment"
          value={equipmentValue}
          options={equipmentSelect.value}
          onChange={(val) => changeTracker(val, 'equipment')}
          variant='outlined'
          optional={true}
          grouping={true}
        />
        <ModalSelectStyled
          text={categorySelect.buttonText}
          multiple={true}
          header="Categories"
          value={categoryValue}
          options={categorySelect.value}
          onChange={(val) => changeTracker(val, 'categories')}
          variant='outlined'
          optional={true}
          limit={LIMITS.exercises.categories}
        />
        <ModalSelectStyled
          text={musclegroupSelect.buttonText}
          multiple={true}
          header="Muscle Groups"
          value={musclegroupValue}
          options={musclegroupSelect.value}
          onChange={(val) => changeTracker(val, 'musclegroup')}
          variant='outlined'
          optional={true}
        />
        <MultiTextInputStyled
          header="Tags"
          type="text"
          onChange={(val) => changeTracker(val,'tags')}
          onBlur={handleBlur}
          value={values.tags}
          options={[]}
          optional={true}
          tooltipTitle={tooltips.exercise.tags.title}
          limit={LIMITS.exercises.tags}
        />
      </React.Fragment>
    );

    let buttons = (
      <React.Fragment>
        <ButtonContainer>
          {
            saveButton &&
              <Button variant='outlined' onClick={this.manualSubmit} disabled={isSubmitting}>Save</Button>
          }
        </ButtonContainer>
      </React.Fragment>
    );

    return (
      <React.Fragment>
        <HeaderContainer>
          <Header>More Details</Header>
          <SubHeader>Add more info to help members understand how best to utilize this exercise. This will also help you plan future classes.</SubHeader>
        </HeaderContainer>
        {/* {errors.last && touched.last && <ErrorTextBox text={errors.last}/>} */}
        {fields}
        {buttons}
      </React.Fragment>
    );
  }
}
